<template>
  <div class="-mx-6 -mt-4">
    <StatusQuickSheetInner
      :title="title"
      :current-log="currentLog"
      :title-type="titleType"
      :title-name="titleName"
      @status-changed="handleStatusChanged"
      @close="handleClose" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStoreTitleLogs } from '@/stores/storeTitleLogs'
import StatusQuickSheetInner from '@/components/Sheets/StatusQuickSheetInner.vue'

const props = defineProps({
  title: {
    type: Object,
    default: null
  },
  titleType: {
    type: String,
    default: 'movie'
  },
  titleName: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['close'])

const storeTitleLogs = useStoreTitleLogs()

// Get current log from store based on title
const currentLog = computed(() => {
  if (!props.title?.id) return null
  return storeTitleLogs.getLatestLogByTmdb(props.title.id, props.titleType)
})

const handleStatusChanged = () => {
  emit('close')
}

const handleClose = () => {
  emit('close')
}
</script>
